import { cx } from './cx';

/**
 * Loading placeholder. Size it via className (h-* w-* / aspect-*). Pairs with
 * Button's loading state for full-surface loading. Decorative, so aria-hidden.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden="true" className={cx('animate-pulse rounded-sm bg-bone', className)} />;
}
